import React, { useId } from 'react';
import WritingJobFlow from './WritingJobFlow.jsx';
import { writingJobNavigationView, writingJobTarget } from './model.js';
import './writingJobFlow.css';
export default function WritingJobNavigation({ config, mission, step, onSelectStep, packId, independent = false }) {
    const controlId = useId();
    if (independent) return null;
    const view = writingJobNavigationView({ config, mission, stepId: step?.id, packId });
    if (!view || typeof onSelectStep !== 'function') return null;
    const select = request => { const id = writingJobTarget(view, request); if (id) onSelectStep(id); };
    return <section className="writing-job-navigation selectable" aria-label="Writing job and level navigation">
        <p className="writing-job-position"><strong>Position</strong> — {view.question.position}</p>
        <WritingJobFlow currentJob={view.active.job} onSelectJob={job => select({ job })} bodyPlan={view.bodyPlan} />
        <div className="writing-job-choosers">
            <div><label htmlFor={controlId + '-function'}>Writing job</label><select id={controlId + '-function'} value={view.active.functionValue} onChange={event => select({ functionValue: event.target.value })}>{view.functions.map(row => <option key={row.value} value={row.value}>{row.label}</option>)}</select></div>
            <div><label htmlFor={controlId + '-level'}>Level</label><select id={controlId + '-level'} value={view.active.levelValue} onChange={event => select({ levelValue: event.target.value })}>{view.levels.map(row => <option key={row.value} value={row.value}>{row.label}</option>)}</select></div>
        </div>
    </section>;
}
